// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialLogin-displayFlex-zoGM7 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.SocialLogin-marginRight-PaJh2 {
	margin-right: 23px;
}

.SocialLogin-center-MuwbW{
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/SocialLogin/SocialLogin.css"],"names":[],"mappings":"AAAA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AACA;CACC,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB","sourcesContent":[".displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.marginRight {\n\tmargin-right: 23px;\n}\n.center{\n\tjustify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayFlex": `SocialLogin-displayFlex-zoGM7`,
	"marginRight": `SocialLogin-marginRight-PaJh2`,
	"center": `SocialLogin-center-MuwbW`
};
module.exports = ___CSS_LOADER_EXPORT___;
